var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmergeLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 100,
    viewBox: "0 0 80 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0231 33.7932C27.7015 33.7932 30.3799 33.8192 33.0583 33.7932C36.8967 33.756 39.3719 31.961 40.6317 28.3114C41.3595 26.2042 41.969 24.0524 42.7448 21.9638C43.9824 18.6338 46.4207 16.9652 49.9303 16.9577C56.484 16.9466 69.8944 16.9577 76.4482 16.9503C78.831 16.9503 79.278 16.5043 79.2817 14.1778C79.2891 10.3387 79.2891 6.49594 79.2817 2.65686C79.2817 0.319218 78.9677 0.0107531 76.5811 0.00703667C71.7933 -0.000396206 60.1488 -0.00411265 55.3609 0.00703667C51.5447 0.0144696 49.003 1.87269 47.8171 5.49994C47.2113 7.34701 46.6276 9.20523 46.0143 11.0523C44.7139 14.9694 42.2424 16.8202 38.1232 16.8425C31.0006 16.8797 10.2126 16.8499 3.08994 16.8537C0.304418 16.8537 0.0384267 17.1175 0.0347324 19.8863C0.0273437 23.6102 0.0199551 27.3377 0.0421211 31.0616C0.053204 33.232 0.618436 33.7783 2.80917 33.7895C5.6575 33.8043 22.1748 33.7895 25.0231 33.7895V33.7932Z",
    fill: "url(#paint0_linear_1074_18463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.044 50.1545C13.9704 50.1545 17.6979 50.1359 14.6243 50.1545C12.8325 50.1656 12.4705 50.5299 12.4668 52.3138C12.4557 56.0971 12.452 59.8841 12.4668 63.6675C12.4742 65.325 13.0025 65.875 14.6501 65.8825C19.2606 65.9048 23.269 65.9457 27.8795 65.8825C31.282 65.8379 33.6574 63.9759 34.7288 60.698C35.3383 58.8287 35.911 56.9444 36.5464 55.0825C37.6251 51.9235 39.9562 50.2325 43.2553 50.2288C50.0935 50.2177 56.928 50.2363 63.7662 50.2288C66.0197 50.2288 66.4482 49.8014 66.4593 47.501C66.4741 43.9815 66.4741 40.4657 66.4593 36.9463C66.4519 34.8651 66.0788 34.4823 64.0691 34.4786C58.716 34.4674 53.363 34.4637 48.0099 34.4786C44.9473 34.486 42.6236 36.1175 41.5854 39.0126C40.9389 40.8151 40.3811 42.6473 39.7974 44.4721C38.5635 48.3409 36.2213 50.0913 32.1464 50.1545C32.0947 50.1545 32.0393 50.1545 31.9876 50.1545C29.0728 50.1545 19.9589 50.1545 17.044 50.1545Z",
    fill: "url(#paint1_linear_1074_18463)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7196 83.0298C9.41314 83.0298 5.63754 83.0112 2.33112 83.0298C0.406376 83.041 0.0147773 83.4423 0.011083 85.36C-0.00369432 89.4295 -0.00369432 93.499 0.011083 97.5685C0.0184716 99.3487 0.587398 99.9508 2.36067 99.9619C7.31846 99.9879 12.7491 100.029 17.7032 99.9619C21.3606 99.9136 23.9171 97.8993 25.066 94.3761C25.7236 92.3655 26.3368 90.3401 27.0203 88.3369C28.1803 84.9401 30.6888 83.1302 34.2316 83.1227C41.5833 83.1116 68.9472 83.1227 76.2989 83.1153C78.7224 83.1153 79.1805 82.6545 79.1916 80.183C79.21 76.3997 79.2063 72.6164 79.1916 68.8367C79.1805 66.5994 78.7852 66.1869 76.624 66.1832C70.8682 66.172 45.0966 66.1646 39.3446 66.1832C36.0529 66.1943 33.5519 67.9485 32.4399 71.0592C31.7453 72.9954 31.1432 74.9651 30.5188 76.9274C29.1926 81.0898 26.673 82.9629 22.2916 83.0261C22.2361 83.0261 22.177 83.0261 22.1216 83.0261C18.9888 83.0261 15.8523 83.0261 12.7196 83.0261V83.0298Z",
    fill: "url(#paint2_linear_1074_18463)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1074_18463",
    x1: 31.2101,
    y1: 25.6973,
    x2: 48.0064,
    y2: 8.24192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11E6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1074_18463",
    x1: 30.4793,
    y1: 61.0703,
    x2: 42.6212,
    y2: 46.3179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11E6C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1074_18463",
    x1: 29.6031,
    y1: 97.4918,
    x2: 40.2024,
    y2: 82.1883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11E6C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergeLogoLarge);
export default __webpack_public_path__ + "static/media/EmergeLogo_Large.4ce6b5aab949a1ec3dfa061d38e99c49.svg";
export { ForwardRef as ReactComponent };